<template>
  <v-sheet color="grey800" class="px-5 pt-4 pb-2 mb-6 grey200--text bdrd-2">
    <label
      v-t="'page.account.affiliates.create.label'"
      for="fieldCreateCode" class="green400--text d-block font-weight-bold"
    />
    <p v-t="'page.account.affiliates.create.desc'" class="text-body-2 green200--text" />

    <v-form v-model="valid" @submit.prevent="onCreate">
      <v-text-field
        id="fieldCreateCode"
        v-model.trim="input"
        :rules="rules"
        :placeholder="$t('page.account.affiliates.create.placeholder')"
        class="has-btn-appended rounded-0"
        dense solo flat
        background-color="grey600"
      >
        <template #append-outer>
          <v-btn
            v-t="'cta.create'"
            class="px-8 font-weight-semibold text-caption green500--text rounded-0" color="green800"
            height="38" :ripple="false"
            depressed
            :disabled="!valid"
            :loading="loading"
            @click="onCreate"
          />
        </template>
      </v-text-field>
    </v-form>
  </v-sheet>
</template>

<script>
import { ALPHANUM_RE } from '@/utils/constants/regexes'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: true,
      input: this.value,
      rules: [
        v => !!v || this.$t('form_validation.required'),
        v => ALPHANUM_RE.test(v) || this.$t('form_validation.alphanumeric'),
        v => v.length <= 16 || this.$t('form_validation.max_length', [16]),
        v => v.length >= 3 || this.$t('form_validation.min_length', [3]),
      ],
    }
  },
  watch: {
    value(val) {
      this.input = val
    },
  },
  methods: {
    onCreate() {
      this.$emit('submit', this.input)
    },
  },
}
</script>
